import { render, staticRenderFns } from "./delete-videos-dialog.vue?vue&type=template&id=6dca2aca&scoped=true"
import script from "./delete-videos-dialog.vue?vue&type=script&lang=js"
export * from "./delete-videos-dialog.vue?vue&type=script&lang=js"
import style0 from "./delete-videos-dialog.vue?vue&type=style&index=0&id=6dca2aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca2aca",
  null
  
)

export default component.exports